import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./BeforeQuizStartScreen.module.css";
import PlatformPart from "./PlatformPart";
import { QuizGameScreenUrl } from "../../App";
import gameConfig from "../../gameConfig";
import { getActiveGameKeys } from "../../helpers/gameHelpers";
import ExplanationPanel from "../../components/ExplanationPanel/ExplanationPanel";
import withCheckForActiveCategory from "../../HOC/WithCheckForActiveCategory";

import MenuStationLeft from "../../images/menu-station-left.png";
import MenuStationRight from "../../images/menu-station-right.png";
import MenuTextPanel from "../../images/menu-text-panel.png";

const keysFirstPlayer = gameConfig.keys.keysFirstPlayer;
const keysSecondPlayer = gameConfig.keys.keysSecondPlayer;
const activeKeys = getActiveGameKeys();
const keysToCheckPass = [
  keysFirstPlayer[0],
  keysFirstPlayer[2],
  keysSecondPlayer[0],
  keysSecondPlayer[2],
];
const keysToCheckFail = [keysFirstPlayer[1], keysSecondPlayer[1]];

function BeforeQuizStartScreen({ sounds }) {
  const [keysPressed, setKeysPressed] = useState([]);
  const [isTimerShown, setIsTimerShown] = useState(false);
  const [isTimerAnimated, setIsTimerAnimated] = useState(false);
  const [timerPanelText, setTimerPanelText] = useState(
    gameConfig.timerCountBeforeGameStart
  );

  const { t, i18n } = useTranslation("common");

  const navigate = useNavigate();

  const onKeyDown = useCallback(
    (e) => {
      if (activeKeys.includes(e.key)) {
        sounds.buttonSound();
        setKeysPressed((keysPressed) => {
          let newKeyPressed = keysPressed;
          if (!keysPressed.includes(e.key)) {
            newKeyPressed = [...keysPressed, e.key];
          }
          return newKeyPressed;
        });
      }
    },
    [setKeysPressed]
  );

  const startTimer = useCallback(() => {
    let count = 0;
    const configTimerCount = gameConfig.timerCountBeforeGameStart;
    const intervalId = setInterval(() => {
      if (count < configTimerCount) {
        sounds.answerPanelSound();
      }
      if (count < configTimerCount - 1) {
        setTimerPanelText(configTimerCount - 1 - count);
      } else if (count === configTimerCount - 1) {
        setTimerPanelText(t("go"));
      } else if (count === configTimerCount) {
        clearInterval(intervalId);
        setIsTimerAnimated(false);
        sounds.downSound();
        setTimeout(() => {
          navigate(QuizGameScreenUrl);
        }, 1000);
        return;
      }
      count++;
    }, 1000);
  }, [setTimerPanelText]);

  useEffect(() => {
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  useEffect(() => {
    if (keysToCheckFail.find((r) => keysPressed.includes(r))) {
      setTimeout(() => {
        navigate("/");
      }, 500);
    } else if (keysToCheckPass.every((r) => keysPressed.includes(r))) {
      window.removeEventListener("keydown", onKeyDown);
      sounds.confirmSound();
      setTimeout(() => {
        setIsTimerShown(true);
        setIsTimerAnimated(true);
        sounds.upSound();
        setTimeout(() => {
          startTimer();
        }, 800);
      }, 1000);
    }
  }, [keysPressed]);

  return (
    <>
      <div className={styles.wrapper}>
        {!isTimerShown && (
          <div className={cn(styles.textPanel)}>
            <div className="container">
              <div className={styles.textPanelInner}>
                <img src={MenuTextPanel} alt="text panel" />
                <div className={styles.textPanelTextWrapper}>
                  <h2 className={styles.textPanelTitle}>{t("game-start")}</h2>
                  <p className={styles.textPanelText}>
                    {t("press-blue-and-red")}
                  </p>
                  <p className={styles.textPanelText}>{t("win-who-score-5")}</p>
                </div>
              </div>
            </div>
            {/* <div className={styles.playerInfoPanelsWrapper}>
              <PlayerInfoPanel 
                customStyles={styles.playerInfoPanelLeft} 
                title={`${t('player')} 1`}
                textLines={[
                  { left: t('blue'), right: `${t('button')} A`},
                  { left: t('gold'), right: `${t('button')} S`},
                  { left: t('red'), right: `${t('button')} d`},
                ]}
              />
              <PlayerInfoPanel
                customStyles={styles.playerInfoPanelRight}
                title={`${t('player')} 2`}
                textLines={[
                  { left: t('blue'), right: `${t('button')} J`},
                  { left: t('gold'), right: `${t('button')} K`},
                  { left: t('red'), right: `${t('button')} l`},
                ]}
              />
            </div> */}
          </div>
        )}

        <ExplanationPanel isShown={isTimerAnimated}>
          <div className={styles.timerContent}>{timerPanelText}</div>
        </ExplanationPanel>

        <div className={cn(styles.platform, "container")}>
          <PlatformPart
            image={MenuStationLeft}
            imageAlt="platform left"
            customStyles={styles.platformLeft}
            buttonKeys={keysFirstPlayer}
            keysPressed={keysPressed}
          />
          <PlatformPart
            image={MenuStationRight}
            imageAlt="platform right"
            customStyles={styles.platformRight}
            buttonKeys={keysSecondPlayer}
            keysPressed={keysPressed}
          />
        </div>
      </div>
    </>
  );
}

export default withCheckForActiveCategory(BeforeQuizStartScreen);
